import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ButtonMenu from "./ButtonMenu"
import { getOrganizacionById } from "../../endpoints"
import { useNavigate, useParams } from 'react-router-dom';
import arrow from "./assets/arrow.svg"
import Contacts from './Secciones/Contactos/Contacts';
import Clientes from "./Secciones/Clientes/Clientes";
import Preferencias from "./Secciones/Preferencias/Preferencias";
import Asesores from './Secciones/Asesores/Asesores';
import Seguimientos from "./Secciones/Seguimientos/Seguimientos"

const DetailOrganizacion = ({ user }) => {
  const navigate = useNavigate()
  const params = useParams();
  const [dataOrg, setDataOrg] = useState({});
  const [activeButton, setActiveButton] = useState('');
  const getDataOrgById = async (id) => {
    getOrganizacionById({
      id: id
    }).then((res) => {
      console.log(res)
      if (res.status === 200) {
        setDataOrg(res.data)
      } else {
        console.log(res)
      }
    })
  }
  useEffect(() => {
    getDataOrgById(params.id)
  }, [params.id])

  return (
    <Container>
      <FlexRow>
        <FlexColumn>
          <FlexRow1 onClick={() => navigate("/organizaciones")}>
            <IconArrow src={arrow} alt="icon-volver" />
            <VolverText>Volver al listado</VolverText>
          </FlexRow1>
          <TitleOrg>{dataOrg.name}</TitleOrg>

          <ButtonMenu activeButton={activeButton} setActiveButton={setActiveButton} />
        </FlexColumn>
        {
          activeButton === "contactos" ? <Contacts user={user} /> : null
        }
        {
          activeButton === "seguimientos" ? <Seguimientos user={user}/> : null
        }
        {
          activeButton === "clientes" ? <Clientes user={user}/> : null
        }
                     {
          activeButton === "asesores" ? <Asesores user={user}/> : null
        }
        {
          activeButton === "preferencias" ? <Preferencias user={user}/> : null
        }
   
      </FlexRow>

    </Container>

  );
};

export default DetailOrganizacion;

// Styled components
const FlexColumn = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const FlexRow1 = styled.div`
  width:auto;
  display:flex;
  flex-direction:row;
  align-items:center;
  cursor:pointer;
`;

const IconArrow = styled.img`
  width: 24px;
  height: 24px;
`;

const TitleOrg = styled.h1`
  color: #003049;
  font-family: Montserrat;
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

const VolverText = styled.div`
  color: #003049;
  text-align: center;
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const FlexRow = styled.div`
  display:flex;
  flex-direction:row;
  align-items:start;
  gap:16px;
`;

const Container = styled.div`
  background-color: #ffffff;
  width: -webkit-fill-available;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  display: flex;
  flex-direction: column;
  padding: 16px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  box-sizing: border-box;
  margin: 1%;
`;





